<template>
  <el-form ref="formData" :model="formData" :rules="rules" v-loading="loading">
    <el-form-item prop="email" :label="$t('users.email')" required>
      <el-input
        class="no-border input-lg"
        type="email"
        v-model="formData.email"
        prefix-icon="el-icon-user"
      >
      </el-input>
    </el-form-item>
    <el-form-item prop="password" :label="$t('login.password')" required>
      <el-input 
        v-model="formData.password" 
        show-password
        prefix-icon="now-ui-icons objects_key-25"
      >
      </el-input>
    </el-form-item>
    <div class="text-center">
      <el-button class="btn-primary btn btn-lg" size="large" round type="primary" @click="onLoginSubmit()">{{$t('login.button_start')}}</el-button>
    </div>
    <div class="text-center">
      <h4>
        <el-link icon="el-icon-question" @click="showRestoreModal">{{$t('login.button_forgot')}}</el-link>
      </h4>

      <h4>
        <el-link icon="el-icon-edit" @click="showSignUpModal">{{$t('menu.signup')}}</el-link>
      </h4>
    </div>
  </el-form>
</template>
<script>
import { Card, Alert } from '@/components';
import { Input, Button, Form, FormItem, Link, Message } from 'element-ui';
import Auth from '@/providers/Auth'

const AuthProvider = new Auth()

export default {
  components: {
    Card,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [Link.name]: Link,
    Alert
  },
  data: () => ({
      formData: {
        email: null,
        password: null
      },
      loading: false,
      error: null,
      rules: {
        email: [{ required: true, message: 'Correo electrónico es obligatorio', trigger: 'blur', type: 'email' }],
        password: [{ required: true, message: 'Contraseña es obligatorio', trigger: 'change' }]
      }
  }),
  methods: {
    onLoginSubmit () {
      this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.loading = true
            AuthProvider.login(this.formData).then((resp)=> {
              this.error = null
              this.$store.dispatch('SET_AUTH_TOKEN', resp.data.token).then(() => {
                Message({ type: 'success', message: 'Bienvenido' })
                this.loading = false
              })
              .catch((err) => {
                throw err
              })
            }).catch((err)=>{
              this.loading = false
              if(err && err.status && (err.status === 400)) {
                Message({ type: 'error', message: 'Wrong credentials' })
              }else if(err && err.status && (err.status === 403)) {
                Message({ type: 'error', message: 'Email not confirm yet, please confirm and try again!' })
              }else {
                Message({ type: 'error', message: 'Error comunication' })
              }
            })
          } else {
            return false;
          }
      })
    },
    showSignUpModal() {
      this.$refs['formData'].resetFields();
      this.$emit('show-signup');
    },
    showRestoreModal() {
      this.$emit('show-restore');
    }
  }
};
</script>
<style></style>
